import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function SecureIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M12 0c-.67 0-1.201.179-2.023.414-.821.235-1.792.55-2.749.887-.957.338-1.896.696-2.665 1.025-.385.165-.726.323-1.016.475-.291.152-.507.245-.8.539-.263.263-.545.69-.661 1.137-.116.448-.133.887-.137 1.495-.01 1.217.071 3.166.071 6.835 0 4.144 2.515 7.006 4.894 8.719 2.378 1.712 4.753 2.425 4.753 2.425a1.15 1.15 0 0 0 .666 0s2.375-.713 4.753-2.425c2.379-1.713 4.894-4.575 4.894-8.719 0-3.669.08-5.618.071-6.835-.004-.608-.02-1.045-.137-1.492a2.666 2.666 0 0 0-.658-1.14 1.15 1.15 0 0 0 0-.002c-.294-.294-.51-.385-.8-.537-.291-.152-.632-.31-1.016-.475-.77-.33-1.711-.687-2.668-1.025a49.681 49.681 0 0 0-2.747-.887C13.204.179 12.67 0 12 0Zm0 2.302c-.09 0 .632.108 1.391.325.76.218 1.697.52 2.617.843.92.325 1.827.672 2.526.971.35.15.647.29.856.398.208.108.348.238.236.126.092.092.038 0 .061.09s.059.39.063.935c.008 1.09-.072 3.115-.072 6.817 0 3.225-1.9 5.385-3.936 6.85-1.87 1.347-3.449 1.825-3.742 1.92-.293-.095-1.872-.573-3.742-1.92-2.036-1.465-3.936-3.625-3.936-6.85 0-3.702-.08-5.726-.072-6.817.004-.545.042-.845.065-.935.024-.09-.033.002.059-.09-.117.117.03-.017.238-.126.209-.109.507-.248.856-.398a43.33 43.33 0 0 1 2.527-.97 47.59 47.59 0 0 1 2.614-.844c.759-.217 1.481-.325 1.391-.325z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M16.486 8.53c.45.45.45 1.178 0 1.627l-4.485 4.489a1.15 1.15 0 0 1-1.628 0l-2.178-2.182a1.15 1.15 0 1 1 1.63-1.626l1.363 1.366 3.671-3.674a1.15 1.15 0 0 1 1.627 0Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconWrapper>
  );
}
